import {Presenter} from '../../../support/with_presenter';
import {Try} from '../../../support/monads/try';
import {Race} from '../../../models/race';
import {toast} from 'react-toastify';
import {runInAction} from 'mobx';
import {StartIntentInteractor} from './start_intent_button_presenter';
import {SystemReadyProvider, SystemStatus} from '../../../business/start_preparation/SystemReadyProvider';
import {CompositeSubscription} from '../../../support/composite_subscription';

export interface RaceStarter {
    start(): Promise<Try<Race>>;
}

export interface RaceAborter {
    abort(): Promise<Try<Race>>;
}

export class RaceControlButtonPresenter implements Presenter {
    public intentToStartAtMillis: number | null = null;
    public systemStatus: SystemStatus = {
        ready: false,
    };

    public busy = false;

    private subscriptions = new CompositeSubscription();

    constructor(
        private systemReadyProvider: SystemReadyProvider,
        private startIntentInteractor: StartIntentInteractor,
        private raceStarter: RaceStarter,
        private raceAborter: RaceAborter,
    ) {}

    public mount(): void {
        this.subscriptions.add(
            this.systemReadyProvider.get().subscribe((systemStatus) => {
                runInAction(() => {
                    this.systemStatus = systemStatus;
                });
            }),
        );
        this.subscriptions.add(
            this.startIntentInteractor.intentToStartAtMillis.subscribe((intentToStartAtMillis) => {
                runInAction(() => {
                    this.intentToStartAtMillis = intentToStartAtMillis;
                });
            }),
        );
    }

    public unmount(): void {
        this.subscriptions.clear();
    }

    public async onStartIntentClick() {
        await this.startIntentInteractor.send();
    }

    public async onStartClick() {
        this.busy = true;
        (await this.raceStarter.start()).fold(
            () => {
                runInAction(() => {
                    this.busy = false;
                });
            },
            () => {
                runInAction(() => {
                    this.busy = false;
                });
                toast('Something went wrong while requesting a start, please check your setup and try again.', {
                    type: toast.TYPE.ERROR,
                });
            },
        );
    }

    public async onAbortClick() {
        this.busy = true;
        (await this.raceAborter.abort()).fold(
            () => {
                runInAction(() => {
                    this.busy = false;
                });
            },
            () => {
                runInAction(() => {
                    this.busy = false;
                });
                toast('Something went wrong while aborting the race, please check your setup and try again.', {
                    type: toast.TYPE.ERROR,
                });
            },
        );
    }
}
